"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
const rewardsbrand04 = _ref => {
  let {
    title,
    description,
    ...props
  } = _ref;
  return /*#__PURE__*/_react.default.createElement("svg", _extends({}, props, {
    viewBox: "0 0 71 71",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": (title ? `title-rewardsbrand04` : '') + (description ? ` desc-rewardsbrand04` : '') || undefined,
    role: "img"
  }), title && /*#__PURE__*/_react.default.createElement("title", {
    id: "title-rewardsbrand04"
  }, title), description && /*#__PURE__*/_react.default.createElement("desc", {
    id: "desc-rewardsbrand04"
  }, description), /*#__PURE__*/_react.default.createElement("g", {
    fillRule: "evenodd",
    clipRule: "evenodd"
  }, /*#__PURE__*/_react.default.createElement("path", {
    d: "M68.247 49.214a3 3 0 0 1-1.245 2.43l-24 17.334a3 3 0 0 1-3.51 0l-24-17.334a3 3 0 0 1-1.245-2.43V25.28a3 3 0 0 1 1.245-2.43l24-17.334a3 3 0 0 1 3.51 0l24 17.334a3 3 0 0 1 1.245 2.43v23.934Z",
    fill: "#F1C4DC",
    fillOpacity: ".5"
  }), /*#__PURE__*/_react.default.createElement("g", {
    fill: "#D01481"
  }, /*#__PURE__*/_react.default.createElement("path", {
    d: "M36.426 15.18a1 1 0 0 1 1.148 0l15 10.5a1 1 0 0 1 .426.82v15a1 1 0 0 1-.426.82l-15 10.5a1 1 0 0 1-1.148 0l-15-10.5A1 1 0 0 1 21 41.5v-15a1 1 0 0 1 .427-.82l15-10.5ZM23 27.02v13.96l14 9.8 14-9.8V27.02l-14-9.8-14 9.8Z"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "m35.83 3.08-24 17.334c-.52.375-.83.978-.83 1.62v23.933a2 2 0 0 0 .83 1.619l24 17.334a2 2 0 0 0 2.34 0l24-17.334c.52-.375.83-.978.83-1.62V22.034a2 2 0 0 0-.83-1.62l-24-17.334a2.001 2.001 0 0 0-2.34 0Zm-1.17-1.622a4 4 0 0 1 4.68 0l24 17.334a4.001 4.001 0 0 1 1.66 3.24v23.936a4 4 0 0 1-1.66 3.24l-24 17.334a4 4 0 0 1-4.68 0l-24-17.334A4 4 0 0 1 9 45.968V22.032a4 4 0 0 1 1.66-3.24l24-17.334Z"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M37 .702a1 1 0 0 1 1 1V16a1 1 0 1 1-2 0V1.702a1 1 0 0 1 1-1ZM9.436 20.218a1 1 0 0 1 1.341-.447l11.67 5.835a1 1 0 1 1-.894 1.788L9.883 21.56a1 1 0 0 1-.447-1.341ZM22.894 41.053a1 1 0 0 1-.447 1.341l-11.67 5.835a1 1 0 1 1-.894-1.788l11.67-5.836a1 1 0 0 1 1.341.448ZM37 51a1 1 0 0 1 1 1v14.298a1 1 0 1 1-2 0V52a1 1 0 0 1 1-1ZM51.105 41.053a1 1 0 0 1 1.342-.447l11.67 5.834a1 1 0 0 1-.894 1.79l-11.67-5.836a1 1 0 0 1-.447-1.341ZM64.564 20.218a1 1 0 0 1-.447 1.341l-11.67 5.835a1 1 0 1 1-.894-1.788l11.67-5.835a1 1 0 0 1 1.341.447ZM7 0a1 1 0 0 1 1 1v12a1 1 0 1 1-2 0V1a1 1 0 0 1 1-1Z"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M0 7a1 1 0 0 1 1-1h12a1 1 0 1 1 0 2H1a1 1 0 0 1-1-1ZM64 57a1 1 0 0 1 1 1v12a1 1 0 1 1-2 0V58a1 1 0 0 1 1-1Z"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M57 64a1 1 0 0 1 1-1h12a1 1 0 1 1 0 2H58a1 1 0 0 1-1-1Z"
  }))));
};
var _default = exports.default = rewardsbrand04;